<template>
  <div class="upload_wrapper custom-file">
    <div class="img_wrapper img-thumbnail rounded-circle">
      <div
        class="img"
        :style="{
          backgroundImage: `url('${image}')`
        }"
      />
    </div>

    <input
      ref="fileInput"
      type="file"
      class="file_input"
      lang="zh-TW"
      @change="onChange"
    >
    <button-wrapper
      class="upload_button"
      fill
    >
      上傳 LOGO
    </button-wrapper>
  </div>
</template>
<script>
import ButtonWrapper from '~components/common/buttons'
import { isMimeTypeAvailable } from '~utils/file'
export default {
  name: 'UploadImage',
  components: {
    ButtonWrapper
  },
  props: {
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: '上傳檔案'
    },
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      image: 'https://via.placeholder.com/300'
    }
  },
  watch: {
    url (value) {
      this.image = value
    }
  },
  created () {
    if (this.url) {
      this.image = this.url
    }
  },
  methods: {
    reset () {
      const input = this.$refs.fileInput
      input.type = 'text'
      input.type = 'file'
    },
    onChange (e) {
      const availableFiles = Array.from(e.target.files).map((file) => {
        if (isMimeTypeAvailable(file)) {
          return file
        }
      })
      this.previewImage(availableFiles[0])
      this.$emit('change', availableFiles[0])
      console.log('emitted')
      this.reset()
      console.log('reseted')
    },
    uploadImage () {
      // do nothing
    },
    previewImage (file) {
      const _this = this
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        _this.setPreviewImage(e.target.result)
      }
    },
    setPreviewImage (dataUrl) {
      this.image = dataUrl
    }
  }
}
</script>
<style lang="scss" scoped>
.upload_wrapper {
  width: 100%;
  height: 100%;
  display: block;
  position: relative;
  &:hover {
    .upload_button {
      opacity: 0.75;
    }
  }
}

.upload_button {
  position: absolute;
  bottom: 0;
  top: 0;
  margin: auto 0;
  opacity: 0;
  transition: 0.75s ease;
  pointer-events: none;
  z-index: 3;

}

.file_input {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    margin: 0;
    opacity: 0;
    top: 0;
    border-radius: 50%;
    cursor: pointer;
}

.img_wrapper {
  height: 150px;
  width: 150px;
}

.img {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  border-radius: 50%;
  overflow: hidden;
}
</style>
